import React from 'react';
import SwfPlayer from 'react-swf';

import { PlayerType } from '../../constants';
import { InitPlayerFn } from '../../types';
import { getPlayerType } from '../../utils';
import GridPlayer from '../GridPlayer';
import TwitchWrapper from '../TwitchWrapper';
import YouTubeEmbedVideo from '../YouTubeEmbedVideo';

import './streamPlayer.scss';

interface Props {
    playerNodeId: string;
    autoplay?: boolean;
    url: string;
    togglePlayStatus: PropsFromReactComponent<
        typeof TwitchWrapper
    >['changePlayStatus'];
    initPlayer?: InitPlayerFn;
}

const embedProps = {
    width: '100%',
    height: '100%',
    allownetworking: 'all',
    allowscriptaccess: 'always',
    quality: 'high',
    bgcolor: '#000',
    wmode: 'window',
    type: 'application/x-shockwave-flash',
};

const StreamPlayer: React.FC<Props> = ({
    url,
    autoplay,
    playerNodeId,
    initPlayer,
    togglePlayStatus,
}) => {
    const playerType = getPlayerType(url);

    let gridEmbedVideoToken = { token: '', seriesId: '' };

    try {
        gridEmbedVideoToken = JSON.parse(url);
    } catch (error) {
        console.error(error);
    }

    if (gridEmbedVideoToken.token) {
        return <GridPlayer gridEmbedVideoToken={gridEmbedVideoToken} />;
    }

    if (playerType === PlayerType.SWF) {
        return <SwfPlayer id="uniqId2" src={url} />;
    }

    if (playerType === PlayerType.DOUYU) {
        return <embed src={url} {...embedProps} />;
    }

    if (playerType === PlayerType.YOUTUBE) {
        return (
            <YouTubeEmbedVideo
                key={url} // key needed to disable youtube inner history state (spfjs framework)
                url={url}
                autoplay={autoplay}
                togglePlayStatus={togglePlayStatus}
                initPlayer={initPlayer}
            />
        );
    }

    if (playerType === PlayerType.TWITCH) {
        return (
            <TwitchWrapper
                playerNodeId={playerNodeId}
                autoplay={autoplay}
                streamUrl={url}
                changePlayStatus={togglePlayStatus}
                initPlayer={initPlayer}
            />
        );
    }

    return <iframe title="stream" src={url} styleName="container" />;
};

export default React.memo(StreamPlayer);
